export default __webpack_public_path__ + "static/media/banker_8.c955fd18.mp3";